import CommentsItem from "./CommentsItem";
import React from "react";
// TODO: Add button that switches the view from comments to history
// Todo: Add button that sorts from oldest to newest
export default function CommentsList({
   comments,
   users,
   projectId,
   sectionId,
   getComments,
}) {
   if (comments.length === 0) {
      return null;
   } else {
      return (
         <div className="comments-list">
            {comments.map((comment) => {
               const user = users.find((user) => {
                  return user.id === comment.user;
               });
               return (
                  <CommentsItem
                     getComments={getComments}
                     sectionId={sectionId}
                     username={user.username}
                     key={comment.id}
                     commentId={comment.id}
                     comment={comment}
                     projectId={projectId}
                  />
               );
            })}
         </div>
      );
   }
}
